import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'
import { useStyles } from '../style'
import { OptionCard } from '../components'
import useKeyboardNavigation from '../../../hooks/useKeyboardNavigation'

const TimeAvailablePage = ({
  title,
  timeOptions,
  selectedTime,
  onSelectTime
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const { focusedIndex, handleKeyDown } = useKeyboardNavigation(
    timeOptions.length,
    isMobile ? 1 : 3,
    (index) => onSelectTime(timeOptions[index])
  )

  return (
    <Box className={classes.content} data-test='time-available-page' onKeyDown={handleKeyDown}>
      <Typography
        id='lpq-dialog-title'
        className={classes.question}
        data-test='time-available-title'
        component='h2'
      >
        {title || 'How much time do you usually have for learning?'}
      </Typography>
      <Box
        className={classes.threeColumnGrid}
        data-test='time-options-grid'
        role='group'
        aria-label='Time available options'
      >
        {timeOptions.map((time, index) => {
          const isSelected = selectedTime === time
          return (
            <OptionCard
              key={time}
              text={time}
              isSelected={isSelected}
              onClick={() => onSelectTime(time)}
              variant='timeRole'
              hasSelection={selectedTime !== ''}
              isFocused={focusedIndex === index}
              onKeyDown={handleKeyDown}
            />
          )
        })}
      </Box>
    </Box>
  )
}

export default TimeAvailablePage
